const noop = (): void => {};

export { noop };
